module.exports = __webpack_public_path__ + "static/media/Got It.4b958102.jpg";